import React from 'react';

const Button = ({
    type,
    label,
    bgcolor,
    onClick,
    children,
    btn_styles,
    btn_disabled
}) => {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={btn_disabled}
            className={`btn btn-${bgcolor} ${btn_styles}`}
        >
            {label}
            {children}
        </button>
    )
}

export default Button;